module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bde0d6784df470f00da33594bf2e5140.png";